import React, { useState, useEffect } from 'react';
import { v4 as uuid } from 'uuid';

import ProgressIndicator from '../Common/ProgressIndicator';
import ErrorIndicator from '../Common/ErrorIndicator';
import Axios from 'axios';

function ListFromApi(props) {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(false);
    const [items, setItems] = useState([]);

    useEffect(() => {
        setIsLoading(true);
        Axios.get(props.url).then(res => {
            setItems(res);
            setIsLoading(false);
        }, err => {
            setIsLoading(false);
            setError(true);
        });
    }, [props.url]);

    if (isLoading)
        return <ProgressIndicator />;

    if (error === true)
        return <ErrorIndicator text={props.errorMessage} />;

    return <>
            {items.map((item) => {
                let key = uuid();
                return React.createElement(props.elementType, { ...item, key, callback: props.callback }, props.children);
            })}
        </>;
}

export default ListFromApi;